<template>
  <div>
    <template v-if="getCurrentRoute.name !== 'client-search' && !isMobile && getCurrentRoute.name !== 'client-communication'">
      <div
        class="layout-content"
        :class="{'layout-content--account-page': isCurrentRouteAccount}"
      >
        <router-view />
      </div>
    </template>
    <template v-else>
      <router-view />
    </template>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState('common', [
      'isMobile'
    ]),
    getCurrentRoute() {
      return this.$store.state.home.activeRoute
    },

    pathInArrayForm() {
      return this.$route.path.split('/').map(val => ({ text: val.replace('-', ' ') }))
    },
    isCurrentRouteAccount() {
      return this.getCurrentRoute.name === 'account'
    }
  },
  methods: {
    redirectToRouteByPath(pathName) {
      const i = this.pathInArrayForm.findIndex(item => item.text === pathName)
      let fullPath = ''
      for (let j = 0; j <= i; j++) {
        fullPath += `${this.pathInArrayForm[j].text}${j === i ? '' : '/'}`
      }
      this.$router.push({ path: fullPath })
    }
  }
}
</script>
